export const actionNeededPluralMapping = {
  '=0': 'No Drivers Action Needed',
  '=1': '1 Driver Action Needed',
  other: '# Drivers Action Needed',
};
